import { ShippingTime } from "@daalder/types";
import DayJs from "./DayJs";

/**
 * @todo Should this be a method in the BasketStore?
 */
export default class ShippingTimeService {
    latestShippingTime(shippingTimes: ShippingTime[]): ShippingTime {
        // Filter out invalid shipping times
        let shippingOptions = shippingTimes.filter((shippingOption) => {
            return shippingOption !== null && shippingOption !== undefined;
        });

        let earliestShippingOption = shippingOptions[0];
        let earliestShippingDate = null;

        for (const shippingOption of shippingOptions) {
            let date = null;

            if (shippingOption.is_workdays) {
                date = DayJs.getInstance()().addBusinessTime(shippingOption.days, "days");
            } else {
                date = DayJs.getInstance()().add(shippingOption.days, "day");
            }

            if (earliestShippingDate === null || date.diff(earliestShippingDate) > 0) {
                earliestShippingOption = shippingOption;
                earliestShippingDate = date;
            }
        }

        return earliestShippingOption;
    }
}
